import React from "react";

export function Comissioners() {
    return (
        <>
        <center>
        <div class="right2">
            <br/>
            <br/>
            <br/>
            <br/>
            <h1 className="text-5xl md:text-5xl font-bold mb-6">Commissioners and Staff</h1><hr/>
            <br/>
            <font size="+1"><a href="https://diuy0t6boke2n.cloudfront.net/2024_Fire_Election_Results%20(2).docx"><button>2024 Fire District Election Results</button></a></font><br/><br/>
            <p>
            Commissioner Charles Dipierro (Chair)<br/>
            Commissioner Leandra Kane<br/>
            Commissioner Todd Grossman <br/>
            Commissioner Anthony Costa <br/>
            Commissioner Vincent DiLieto (Assistant Clerk/Treasurer)<br/>
            Tricia Mercado (Board Secretary)<br/>
            Joseph D. Youssouf (Attorney)<br/>
            Oliver L. E. Soden Agency (Insurance)</p>
        </div>
        </center>
        </>
    )
}